var _style, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeltaCargoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54.42 14.29",
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 54.42 14.29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.09,14.29c-0.95,0-1.58-0.64-1.58-1.58c0-0.95,0.64-1.61,1.59-1.61c0.4,0,0.7,0.09,0.95,0.25 l-0.07,0.44c-0.24-0.17-0.53-0.31-0.89-0.31c-0.69,0-1.09,0.48-1.09,1.22c0,0.72,0.41,1.19,1.09,1.19 c0.36,0,0.68-0.13,0.94-0.31l0.07,0.4C36.85,14.17,36.48,14.29,36.09,14.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.17,14.27l-0.4-0.94h-1.41l-0.38,0.91h-0.46l1.32-3.09h0.47l1.3,3.03L41.17,14.27z M40.07,11.66 l-0.55,1.3h1.1L40.07,11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.54,14.17l-0.47,0.09l-1.04-1.32h-0.35v1.29h-0.45v-3.08h0.92c0.69,0,1.14,0.31,1.14,0.89 c0,0.46-0.31,0.74-0.76,0.85L45.54,14.17z M44.11,11.54h-0.44v1.06h0.39c0.45,0,0.73-0.18,0.73-0.53 C44.79,11.74,44.57,11.54,44.11,11.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.54,14.29c-1.07,0-1.63-0.64-1.63-1.58c0-0.95,0.59-1.61,1.59-1.61c0.45,0,0.77,0.1,1.03,0.26 l-0.08,0.44c-0.25-0.18-0.56-0.32-0.96-0.32c-0.74,0-1.12,0.48-1.12,1.22c0,0.72,0.39,1.19,1.16,1.19 c0.29,0,0.49-0.05,0.69-0.15v-0.8h-0.78l-0.06-0.38h1.3v1.42C49.39,14.16,48.98,14.29,48.54,14.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.86,14.29c-0.94,0-1.54-0.64-1.54-1.58c0-0.95,0.61-1.61,1.55-1.61c0.96,0,1.55,0.65,1.55,1.6 C54.42,13.64,53.82,14.29,52.86,14.29z M52.87,11.49c-0.67,0-1.07,0.48-1.07,1.22c0,0.72,0.41,1.2,1.07,1.2 c0.67,0,1.08-0.47,1.08-1.2C53.95,11.97,53.53,11.49,52.87,11.49z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.27,6.88L4.81,4.73L4.76,0L9.27,6.88z M9.63,7.71L4.81,5.66v2.04H9.63z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "0.35,6.88 4.76,0 4.81,4.73 0.35,6.88  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "0,7.71 4.81,7.71 4.81,5.66 0,7.71  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.02,6.28c0.17,0,0.32,0.14,0.32,0.33c0,0.17-0.14,0.32-0.32,0.32c-0.17,0-0.31-0.14-0.31-0.32 C9.71,6.42,9.85,6.28,10.02,6.28z M10.02,6.88c0.15,0,0.27-0.12,0.27-0.27c0-0.16-0.12-0.28-0.27-0.28 c-0.15,0-0.27,0.12-0.27,0.28C9.75,6.76,9.87,6.88,10.02,6.88z M9.95,6.79H9.91V6.41h0.14c0.08,0,0.11,0.04,0.11,0.11 c0,0.07-0.04,0.1-0.09,0.11l0.11,0.16h-0.05l-0.11-0.16H9.95V6.79z M9.95,6.59h0.06c0.05,0,0.1,0,0.1-0.07 c0-0.05-0.04-0.07-0.08-0.07H9.95V6.59z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.39,6.88h2.17c2.22,0,3.54-1.16,3.54-3.08c0-1.91-1.32-3.06-3.54-3.06h-2.17V6.88z M14.76,1.81h0.79 c1.45,0,2.17,0.71,2.17,1.99c0,1.29-0.72,2.01-2.17,2.01h-0.79V1.81z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "23.76,4.21 26.37,4.21 26.37,3.16 23.76,3.16 23.76,1.81 26.71,1.81 26.71,0.74 22.39,0.74  22.39,6.88 26.81,6.88 26.81,5.81 23.76,5.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "34.59,5.81 31.97,5.81 31.97,0.74 30.59,0.74 30.59,6.88 34.59,6.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "42,0.74 36.5,0.74 36.5,1.81 38.55,1.81 38.55,6.88 39.93,6.88 39.93,1.81 42,1.81  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.96,6.88h-1.44l-0.6-1.54h-2.48l-0.62,1.54h-1.34l2.58-6.16l0,0h1.37L49.96,6.88z M47.53,4.31 l-0.85-2.17l-0.85,2.17H47.53z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeltaCargoLogo);
export default __webpack_public_path__ + "static/media/delta-cargo-logo.221eddeee9a38fe066b065250d828dc7.svg";
export { ForwardRef as ReactComponent };